import {
  IPerformanceSheetConfig,
  IPerformanceSheetConfigCriteria,
  IPerformanceSheetConfigFilter,
} from '../../performance-sheets/config';

export type IAchievementConfigCriteria = IPerformanceSheetConfigCriteria;
export type IAchievementConfigFilter = IPerformanceSheetConfigFilter;

export interface IAchievementConfig
  extends Omit<IPerformanceSheetConfig, 'criteria'> {
  criteria: IAchievementConfigCriteria[];
}

export enum ACHIEVEMENT_CONFIG_CREATED_TYPES {
  MANUAL = 'manual',
  TARGET = 'target',
}
